import { render, staticRenderFns } from "./WebsiteInfoPage.vue?vue&type=template&id=3c0890ae&"
import script from "./WebsiteInfoPage.vue?vue&type=script&lang=js&"
export * from "./WebsiteInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports